import React from 'react';
import './WebDashboardLayoutModeField.css';
import {
  getWebDashboardLayoutOptions,
  normalizeWebDashboardLayoutMode,
} from '../utils/webDashboardLayout';

const WebDashboardLayoutModeField = ({
  value,
  onChange,
  title,
  helperText,
  translations,
  disabled = false,
  readOnly = false,
  compact = false,
}) => {
  const normalizedValue = normalizeWebDashboardLayoutMode(value);
  const options = getWebDashboardLayoutOptions(translations);
  const isLocked = disabled || readOnly;

  return (
    <div
      className={[
        'wd-layout-field',
        compact ? 'wd-layout-field--compact' : '',
        disabled ? 'is-disabled' : '',
        readOnly ? 'is-readonly' : '',
      ].filter(Boolean).join(' ')}
    >
      {title ? (
        <div className="wd-layout-field__header">
          <p className="wd-layout-field__label">{title}</p>
          {readOnly ? (
            <span className="wd-layout-field__lock">
              {translations?.layoutModeLocked || 'Locked'}
            </span>
          ) : null}
        </div>
      ) : null}

      <div className="wd-layout-field__options">
        {options.map((option) => {
          const isActive = option.value === normalizedValue;
          return (
            <button
              key={option.value}
              type="button"
              className={`wd-layout-field__option${isActive ? ' is-active' : ''}`}
              onClick={() => {
                if (isLocked || typeof onChange !== 'function') return;
                onChange(option.value);
              }}
              disabled={isLocked}
              aria-pressed={isActive}
            >
              <p className="wd-layout-field__optionTitle">{option.label}</p>
              <p className="wd-layout-field__optionDescription">{option.description}</p>
            </button>
          );
        })}
      </div>

      {helperText ? <p className="wd-layout-field__helper">{helperText}</p> : null}
    </div>
  );
};

export default WebDashboardLayoutModeField;
